var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup1863(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1863",
    "data-name": "Group 1863",
    transform: "translate(-164 -880)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1850",
    "data-name": "Group 1850",
    transform: "translate(164 879.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    transform: "translate(0 0.5)",
    fill: "none",
    stroke: "#f7921f",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 42.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "tick-svgrepo-com",
    d: "M4.892,17.388,12.508,25l17-17",
    transform: "translate(191.799 908.498)",
    fill: "none",
    stroke: "#f7921f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1863);
export default __webpack_public_path__ + "static/media/Group1863.30517e551045cd132646d5221af5f116.svg";
export { ForwardRef as ReactComponent };